module.exports = __webpack_public_path__ + "img/top-2.fbee2cc.png";